import { createElement, useState } from 'react'
import { Popover } from '@mui/material'
import { WORKSPACE_ICONS } from '@/services/workspaces/workspacePresets'
import { workspaceIconComponent } from '@/services/workspaces/workspaceIconMap'
import CreateWorkspaceIconOption from './CreateWorkspaceIconOption.jsx'
import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspaceIconPicker({ icon, setIcon }) {
  const [anchor, setAnchor] = useState(null)
  const close = () => setAnchor(null)
  return (
    <>
      <button
        type="button"
        className={styles.iconSelector}
        aria-label="Choose workspace icon"
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {createElement(workspaceIconComponent(icon, 24), {
          className: styles.iconGlyph,
          'aria-hidden': true,
        })}
      </button>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { className: styles.iconMenuPaper } }}
      >
        <div className={styles.iconMenu} role="listbox" aria-label="Workspace icon options">
          {WORKSPACE_ICONS.map((id) => (
            <CreateWorkspaceIconOption
              key={id}
              id={id}
              selected={icon === id}
              onSelect={(next) => {
                setIcon(next)
                close()
              }}
            />
          ))}
        </div>
      </Popover>
    </>
  )
}
